module.exports = "/images/vendor/esri-leaflet-geocoder/dist/search-disabled.png?cc6d665e4774644eea65b0ea2027c65f";